import { TResponseType } from '@@types/base';
import instance from '@apis/instance';

const BASE_SETTING_URL = '/setting';

const MESSAGING_TOKEN_URL = `${BASE_SETTING_URL}/message/token`;
const updateMessagingToken = (tokenData: { messagingToken: string }) =>
  instance.patch<TResponseType>(MESSAGING_TOKEN_URL, tokenData);

const COUNTRY_URL = `${BASE_SETTING_URL}/country`;
const updateCountry = (countryData: { country: string }) =>
  instance.patch(COUNTRY_URL, countryData);

export default {
  updateMessagingToken,
  updateCountry,
};
